import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SuperAdminRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user?.is_superadmin) {
    return <Navigate to="/chat" replace />;
  }

  return children;
};

export default SuperAdminRoute;
